import React from 'react'
import { Button } from '@material-ui/core'
import { confirmUserApiCall } from '../service/client'
import Video from '../components/Video'

export default function Welcome(props) {
  const { user, confirmUser } = props
  
  function confirmView() {
    confirmUserApiCall(user).then(() => {
      confirmUser({ ...user, confirmed: true })
    })
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 15, height: '100vh' }}>
      <Video />
      <Button variant='contained' color='primary' onClick={confirmView}>
        I have viewed the training video
      </Button>
    </div>
  )
}